var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoveredEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 4",
    d: "M-7.62939e-06 111C-7.62939e-06 96.4233 2.87109 81.9893 8.44936 68.5221C14.0276 55.055 22.2038 42.8185 32.5111 32.5111C42.8185 22.2038 55.055 14.0276 68.5221 8.44937C81.9893 2.8711 96.4233 -6.37169e-07 111 0L111 111H-7.62939e-06Z",
    fill: "#FFBE50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoveredEllipse);
export default __webpack_public_path__ + "static/media/covered_ellipse.404840dc4937e5e98eee6ebde0a6aa62.svg";
export { ForwardRef as ReactComponent };